export function getAmountOfTextLines({
  text,
  fontSize,
  maxWidth,
  proportion = 0.6,
}: {
  text: string;
  fontSize: number;
  maxWidth: number;
  proportion?: number;
}): number {
  const averageCharWidth = fontSize * proportion;
  const estimatedWidth = text.length * averageCharWidth;

  return Math.ceil(estimatedWidth / maxWidth);
}
